import { render, staticRenderFns } from "./oemForm.vue?vue&type=template&id=2ecb53c4&"
import script from "./oemForm.vue?vue&type=script&lang=js&"
export * from "./oemForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports